import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from 'utils/routeNames';
import { EMAIL_ADDRESS, OFFICE_ADDRESS } from 'utils/constant';
import {
  FooterContainer,
  FooterMainContent,
  SectionTitle,
  FooterFilters,
  SpanWithNoStyle,
  CopyrightITAHText,
} from './styled';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterMainContent>
        {/*<FooterFilters>*/}
        {/*  <SectionTitle>Company</SectionTitle>*/}
        {/*  <Link to={ROUTES.HOT_TOURS}>Hot Tours</Link>*/}
        {/*</FooterFilters>*/}
        <FooterFilters>
          <SectionTitle>Who We Are</SectionTitle>
          <Link to={ROUTES.ABOUT_US}>About Us</Link>
          <Link to={ROUTES.CONTACT_US}>Contact Us</Link>
        </FooterFilters>
        <FooterFilters>
          <SectionTitle>Legals</SectionTitle>
          <Link to={ROUTES.PRIVACY_POLICY}>Privacy Policy</Link>
          <Link to={ROUTES.TERMS_CONDITIONS}>Terms and Condition</Link>
          <Link to={ROUTES.COOKIE_POLICY}>Cookie Policy</Link>
        </FooterFilters>
        <FooterFilters>
          <SectionTitle>Contact Info</SectionTitle>
          <SpanWithNoStyle>{OFFICE_ADDRESS}</SpanWithNoStyle>
          <SpanWithNoStyle>{EMAIL_ADDRESS}</SpanWithNoStyle>
        </FooterFilters>
        {/*<FooterFilters>*/}
          {/*<SectionTitle>Follow Us on</SectionTitle>*/}
          {/*<SocialMediaIcons>*/}
          {/*  {SocialMediaIconsData.map((element) => (*/}
          {/*    <LinkToSocialMedia*/}
          {/*      key={uuid()}*/}
          {/*      href={element.url}*/}
          {/*      target="_blank"*/}
          {/*      rel="noreferrer"*/}
          {/*    >*/}
          {/*      <SocialMediaIcon src={element.img} />*/}
          {/*    </LinkToSocialMedia>*/}
          {/*  ))}*/}
          {/*</SocialMediaIcons>*/}
          {/*    /!* todo *!/*/}
          {/*    /!*<SubscribeBlock>*!/*/}
          {/*    /!*  <EmailAddressInput placeholder="Email Address" />*!/*/}
          {/*    /!*  <EmailAddressSendButton>Subscribe</EmailAddressSendButton>*!/*/}
          {/*    /!*</SubscribeBlock>*!/*/}
        {/*</FooterFilters>*/}
      </FooterMainContent>
      <CopyrightITAHText>
        Copyright © {currentYear} ITAH. All rights reserved.
      </CopyrightITAHText>
    </FooterContainer>
  );
};
